// Informations fixes du site. Les pizzas, prix, horaires et menus se modifient dans backend/content.json.
// Photos : renseignez les champs image ci-dessous (URL ou chemin, ex. "/photos/salle.jpg").

export const restaurant = {
  name: "CAP SUD",
  tagline: "Restaurant & pizzeria",
  since: 2004,
  street: "1 Place Lucien Boilleau",
  zip: "91420",
  city: "Morangis",
  // Adresse publique du site (utilisée pour Google). À changer ici, dans public/index.html, robots.txt et sitemap.xml si vous reliez un nom de domaine.
  siteUrl: "https://cap-sud-morangis.emergent.host",
  phone: "01 64 48 93 38",
  phoneHref: "tel:+33164489338",
  // Numéro du gérant qui reçoit les commandes à emporter (WhatsApp et SMS), format international sans espaces.
  orderPhone: "+33683859685",
  mapsUrl: "https://www.google.com/maps/search/?api=1&query=1+Place+Lucien+Boilleau+91420+Morangis",
  directionsUrl: "https://www.google.com/maps/dir/?api=1&destination=1+Place+Lucien+Boilleau+91420+Morangis",
  heroImage: "",
  carteTileImage: "",
  hallImage: "",
  infoImage: "",
};

export const fullAddress = `${restaurant.street}, ${restaurant.zip} ${restaurant.city}`;

export const offerText = "POUR CHAQUE PIZZA À EMPORTER, UNE CANETTE OFFERTE !";
export const offerNote = "Offre valable uniquement pour les commandes à emporter, non applicable sur place.";

export const eventTypes = ["Anniversaire", "Mariage", "Fête de famille", "Autre événement"];

export const formatPrice = (p) => {
  if (p === null || p === undefined || p === "") return "";
  const n = Number(p);
  return Number.isInteger(n) ? `${n} €` : `${n.toFixed(2).replace(".", ",")} €`;
};

export const navLinks = [
  { to: "/", label: "Accueil", id: "accueil" },
  { to: "/notre-carte", label: "Notre carte", id: "carte" },
  { to: "/nos-pizzas", label: "Nos pizzas", id: "pizzas" },
  { to: "/commander-a-emporter", label: "Commander à emporter", id: "commander" },
  { to: "/location-de-salle", label: "Location de salle", id: "salle" },
  { to: "/informations-pratiques", label: "Informations pratiques", id: "infos" },
  { to: "/contact", label: "Contact", id: "contact" },
];

export const legalLinks = [
  { to: "/mentions-legales", label: "Mentions légales", id: "mentions" },
  { to: "/politique-de-confidentialite", label: "Politique de confidentialité", id: "confidentialite" },
  { to: "/conditions-generales-de-vente", label: "Conditions générales de vente", id: "cgv" },
  { to: "/cookies", label: "Gestion des cookies", id: "cookies" },
];
